import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Application, AssignApplicationsRequest } from '../app/models/application.model';

export interface ApplicationPayload {
  name: string;
  code: string;
  clientId: string;
  defaultRedirectUri: string;
  iconUrl: string;
}
@Injectable({ providedIn: 'root' })
export class ApplicationService {
  constructor(private http: HttpClient) {}


  getApplications() {
    return this.http.get<Application[]>(`${environment.baseUrl}/admin/applications`);
  }

  createApplication(payload: ApplicationPayload) {
    return this.http.post(`${environment.baseUrl}/admin/applications`, payload);
  }
  
  updateApplication(applicationId: number, payload: ApplicationPayload) {
    return this.http.put(
      `${environment.baseUrl}/admin/applications/${applicationId}`,
      payload
    );
  }

  deleteApplication(applicationId: number) {
    return this.http.delete(`${environment.baseUrl}/admin/applications/${applicationId}`);
  }

  getUserApplications(userId: string) {
    return this.http.get<Application[]>(
      `${environment.baseUrl}/admin/users/${userId}/applications`
    );
  }

  assignApplicationsToUser(userId: string, applicationIds: number[]) {
    const payload: AssignApplicationsRequest = { userId, applicationIds };
    return this.http.post(
      `${environment.baseUrl}/admin/users/${userId}/applications`,
      payload
    );
  }

  removeApplicationFromUser(userId: string, applicationId: number) {
    const body = { applicationIds: [applicationId] };
    return this.http.delete(
      `${environment.baseUrl}/admin/users/${userId}/applications`,
      { body }
    );
  }
}